import React, { useEffect, useState, useContext, useCallback } from "react";
import {
  useForm,
  FormProvider,
  useFormContext,
  useWatch,
} from "react-hook-form";
import moment from "moment";
//Function
import { getReportPostpaid } from "../api";
import { ApiDateTimeFormat, ToMonthText } from "../../../utils/date";
//Material Ui
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
//Component
import { BaseContainer } from "../../../stories/base-container";
import Criteria from "../criteria";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ReportTable from "../table";
//Context
import {
  LoadingContext,
  withLoadingContext,
} from "../../../context/loading-context";
const columnsRecords = [
  { id: "BUSINESSDATE", label: "BUSINESSDATE", minWidth: 170, align: "left" },
  {
    id: "RECORDS_CBS",
    label: "RECORDS_CBS",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "RECORDS_T1",
    label: "RECORDS_T1",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "RECORDS_T2",
    label: "RECORDS_T2",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "RECORDS_T3",
    label: "RECORDS_T3",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "RECORDS_DIFF_T1T3",
    label: "RECORDS_DIFF_T1T3",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
];
const columnsAmount = [
  { id: "BUSINESSDATE", label: "BUSINESSDATE", minWidth: 170, align: "left" },
  {
    id: "AMOUNT_CBS",
    label: "AMOUNT_CBS",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "AMOUNT_T1",
    label: "AMOUNT_T1",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "AMOUNT_T2",
    label: "AMOUNT_T2",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "AMOUNT_T3",
    label: "AMOUNT_T3",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
  {
    id: "AMOUNT_DIFF_T1T3",
    label: "AMOUNT_DIFF_T1T3",
    minWidth: 170,
    align: "right",
    dataAlign: "right",
  },
];
const header_number_of_records = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell rowSpan={2} align="center">
          Bill Date
        </TableCell>
        <TableCell colSpan={5} align="center">
          DTN
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell align="center">CBS</TableCell>
        <TableCell align="center">EDW T1</TableCell>
        <TableCell align="center">EDW T2</TableCell>
        <TableCell align="center">EDW T3</TableCell>
        <TableCell align="center">Diff(T1-T3)</TableCell>
      </TableRow>
    </TableHead>
  );
};
const header_number_of_amount = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell rowSpan={2} align="center">
          Bill Date
        </TableCell>
        <TableCell colSpan={5} align="center">
          DTN
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell align="center">CBS</TableCell>
        <TableCell align="center">EDW T1</TableCell>
        <TableCell align="center">EDW T2</TableCell>
        <TableCell align="center">EDW T3</TableCell>
        <TableCell align="center">Diff(T1-T3)</TableCell>
      </TableRow>
    </TableHead>
  );
};

function Postpaid() {
  const methods = useForm({
    defaultValues: { date: moment().format(ApiDateTimeFormat) },
  });
  const Loading_context = useContext(LoadingContext);
  const { actions: load_actions } = Loading_context;
  const [records_lst, setrecords_lst] = useState([]);
  const [amount_lst, setamount_lst] = useState([]);
  const [date, setDate] = useState();
  const { getValues } = methods;
  const query = useCallback(async () => {
    let param = getValues();
    let dat = await load_actions.withLoading(() => getReportPostpaid(param));
    if (!dat) return;
    setrecords_lst(dat?.records?.Rows);
    setamount_lst(dat?.amount?.Rows);
    setDate(ToMonthText(dat?.Date));
  }, [load_actions, getValues]);
  useEffect(() => {
    query();
  }, [query]);

  //changeColor(columnsDom, "DIF", Dom_lst[0]?.DIFF_COLOR_CODE);
  return (
    <FormProvider {...methods}>
      <BaseContainer>
        {Loading_context.state?.isLoading ? (
          <div className="lineLoading">
            <LinearProgress />
          </div>
        ) : null}
        <Box display="flex" justifyContent="center">
          <Typography variant="h4">postpaid revenue report</Typography>
        </Box>
        <Criteria query={query} month />
        <Box display="flex" justifyContent="center">
          {`Month :${date || ""}`}
        </Box>
        <Box display="flex" justifyContent="center">
          Number of records
        </Box>
        <ReportTable
          data={records_lst}
          columns={columnsRecords}
          header={header_number_of_records}
          cellColor={[{ fieldId: "DTN_DIFF", fieldColor: "DIFF_COLOR_CODE" }]}
        />
        <Box display="flex" justifyContent="center" mt={2}>
          {`Month :${date || ""}`}
        </Box>
        <Box display="flex" justifyContent="center">
          Amount
        </Box>
        <ReportTable
          data={amount_lst}
          columns={columnsAmount}
          header={header_number_of_amount}
          cellColor={[{ fieldId: "DTN_DIFF", fieldColor: "DIFF_COLOR_CODE" }]}
        />
      </BaseContainer>
    </FormProvider>
  );
}
export default withLoadingContext(Postpaid);
